import React from "react";

export const schema = {
        title: "",
        description: "",
        type: "object",
        //required: ["title"],
        properties: {
            vertical_jump: {type: "integer", title: "", default: ""},
            broad_jump: {type: "integer", title: "", default: ""},
            lateral_bound_left: {type: "integer", title: "", default: ""},
            lateral_bound_right: {type: "integer", title: "", default: ""}
        }
}
// vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right
export const uiSchema = {

    vertical_jump: {
        "ui:widget": "updown",
        "ui:title": "Vertical Jump",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter inches. Best of 3 attempts.",
        "ui:placeholder": "0"
    },
    broad_jump: {
        "ui:widget": "updown",
        "ui:title": "Broad Jump",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter inches. Best of 3 attempts.",
        "ui:placeholder": "0"
    },
    lateral_bound_left: {
        "ui:widget": "updown",
        "ui:title": "Lateral Bound Left",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter inches. Best of 3 attempts.",
        "ui:placeholder": "0"
    },
    lateral_bound_right: {
        "ui:widget": "updown",
        "ui:title": "Lateral Bound Right",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter inches. Best of 3 attempts.",
        "ui:placeholder": "0"
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/schema/LowerBodyPower.js